import { render, staticRenderFns } from "./ModernSidebarCurrency.vue?vue&type=template&id=029e5850&scoped=true&"
import script from "./ModernSidebarCurrency.vue?vue&type=script&lang=js&"
export * from "./ModernSidebarCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e5850",
  null
  
)

export default component.exports